export default __webpack_public_path__ + "static/media/meris.94ca8db3.png";